













































import { SfTable } from '@storefront-ui/vue';
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'KETable',
  components: {
    SfTable
  },
  props: {
    title: { type: String, default: 'Title' },
    data: {
      type: Array,
      default: () => [
        { id: 1, label: 'Label', entry: 'Description' },
        { id: 2, label: 'Label', entry: 'green-check' },
        { id: 3, label: 'Label', entry: 'red-cross' }
      ]
    },
    titleOnSecondColumn: { type: Boolean, default: false }
  }
});
